"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveDropVoteSummary } from "@/components/waves/drop/WaveDropVoteSummary";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
interface CarouselActiveItemVoteProps {
  readonly drop: ExtendedDrop;
}
export default function CarouselActiveItemVote(t0) {
  const $ = _c(13);
  const {
    drop
  } = t0;
  const [isVotingOpen, setIsVotingOpen] = useState(false);
  const isMobileScreen = useIsMobileScreen();
  const {
    canShowVote,
    isVotingEnded,
    isWinner
  } = useDropInteractionRules(drop);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsVotingOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== canShowVote || $[2] !== drop || $[3] !== isVotingEnded || $[4] !== isWinner) {
    t2 = <WaveDropVoteSummary drop={drop} isWinner={isWinner} isVotingEnded={isVotingEnded} canShowVote={canShowVote} onVoteClick={t1} />;
    $[1] = canShowVote;
    $[2] = drop;
    $[3] = isVotingEnded;
    $[4] = isWinner;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== drop || $[7] !== isMobileScreen || $[8] !== isVotingOpen) {
    t3 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingOpen} onClose={() => setIsVotingOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingOpen} onClose={() => setIsVotingOpen(false)} />;
    $[6] = drop;
    $[7] = isMobileScreen;
    $[8] = isVotingOpen;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-mt-4 tw-flex tw-items-center tw-justify-center tw-px-4 md:tw-px-6 lg:tw-px-8">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}